<script lang="ts">
  // Local development only (SocialReportController@gallery): every template drawn with an
  // activity's real data, plus sample Forecast AI / workout / group sections where the activity
  // has none, so each design can be checked. ?template=<id> draws one template at full size.
  import RenderPage from './RenderPage.svelte'
  import ReportPreview from './ReportPreview.svelte'
  import { TEMPLATES } from './registry'
  import { REPORT_SIZES, SIZE_ORDER } from './context'
  import { withSamples } from './samples'
  import type { ReportData, ReportOptions, ReportSize } from './types'

  export let data: ReportData

  const params = new URLSearchParams(window.location.search)
  const single = params.get('template')
  const sizeParam = params.get('size') as ReportSize | null
  const options: Partial<ReportOptions> | null = {
    ...(params.get('options') ? JSON.parse(params.get('options')!) : {}),
    ...(sizeParam ? { size: sizeParam } : {}),
  }
  const sizes: ReportSize[] = sizeParam ? [sizeParam] : SIZE_ORDER
  // ?only=<template id> shows just that template; ?h=<px> sets the preview height.
  const only = params.get('only')
  const previewHeight = Number(params.get('h')) || 320
  const shown = only ? TEMPLATES.filter((t) => t.id === only) : TEMPLATES

  const sample = withSamples(data)
</script>

{#if single}
  <RenderPage data={sample} templateId={single} {options} />
{:else}
  <div style="display: flex; flex-direction: column; gap: 32px; padding: 24px; background: #222;">
    {#each shown as t}
      <div>
        <div style="color: #fff; font: 600 14px system-ui; margin-bottom: 8px;">{t.type} · {t.name} ({t.id})</div>
        <div style="display: flex; gap: 20px; align-items: flex-start;">
          {#each sizes as size}
            <div style="width: {(previewHeight * REPORT_SIZES[size].width) / REPORT_SIZES[size].height}px;">
              <ReportPreview data={sample} templateId={t.id} options={{ ...options, size }} />
            </div>
          {/each}
        </div>
      </div>
    {/each}
  </div>
{/if}
